import { Component, OnInit } from '@angular/core';
import { PraService } from '../services/pra.service';
import { ngxLoadingAnimationTypes } from 'ngx-loading';
import { Router } from '@angular/router';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import {
  NgbModal,
  ModalDismissReasons,
  NgbModalRef,
  NgbModalOptions,
} from "@ng-bootstrap/ng-bootstrap";
//lodash
import * as _ from "lodash";

@Component({
  selector: 'app-pra-admin-edit',
  templateUrl: './pra-admin-edit.component.html',
  styleUrls: ['./pra-admin-edit.component.css']
})
export class PraAdminEditComponent implements OnInit {
  //Loading
  public loading = false;
  public ngxLoadingAnimationTypes = ngxLoadingAnimationTypes;

  //Current User
  currentUser: any;

  //Form
  addAdmin: FormGroup;
  submitted = false;

  //Lists
  adminList: any;
  userNameList: any;

  //Modal
  modalSubmit: NgbModalRef;
  modalOption: NgbModalOptions = {};
  closeResult: string;

  submitMessage: string;

  constructor(
    private PraService: PraService,
    private router: Router,
    private formBuilder: FormBuilder,
    private modalService: NgbModal
  ) {
    this.currentUser = JSON.parse(localStorage.getItem('currentUser'));

    //Check for super admin permission, otherwise reroute to not authorized
    if (!this.currentUser.payrollsuperadmin) {
      this.router.navigate(['/not-authorized']);
    }

    //Login Form
    this.addAdmin = this.formBuilder.group({
      username: ['', Validators.required],
      region: ['', Validators.required]
    });
  }

  ngOnInit() {
    //Get admin list
    this.getAdminList();
  }

  // convenience getter for easy access to form fields
  get g() { return this.addAdmin.controls; }

  getAdminList() {
    this.PraService.getAllPayrollAdmin().subscribe(
      data => {
        console.log(data);
        console.log(_.lowerCase(data[0].UserLoginID));
        this.adminList = data;
        //Get unique user name list
        let userList = [];
        console.log(_.uniqBy(data, o => o.UserLoginID.trim().toLowerCase()));
        userList = _.uniqBy(data, o => o.UserLoginID.trim().toLowerCase());
        this.userNameList = _.orderBy(userList, [user => user.UserLoginID.toLowerCase()], ['asc']);
      }
    )
  }

  onSubmit(modal) {
    this.submitted = true;

    // stop here if form is invalid
    if (this.addAdmin.invalid) {
      return;
    }

    this.loading = true;

    console.log(`${this.g.username.value} ${this.g.region.value}`);

    //Submit admin form
    this.PraService.updatePayrollAdmin(
      this.currentUser.userId,
      [
        {
          "userID": this.g.username.value,
          "RegionShortName": this.g.region.value,
          "RegionLongName": ""
        }
      ]
    ).subscribe(
      data => {
        this.loading = false;
        console.log(data);
        this.submitMessage = data;

        //Show Modal
        this.modalSubmit = this.modalService.open(
          modal,
          this.modalOption
        );
        this.modalSubmit.result.then(
          (result) => {
            this.closeResult = `Closed with: ${result}`;
          },
          (reason) => {
            //Clear Form
            this.addAdmin.reset();
            this.submitted = false;

            //Reload admin list
            this.adminList = [];
            this.getAdminList();

            this.closeResult = `Dismissed ${this.getDismissReason(
              reason
            )}`;
          }
        );
      },
      error => {
        this.loading = false;
        console.log(error);
        alert(`Something went wrong with the submission. Please contact PAWS.`);
      }
    )

  }

  //Modal
  private getDismissReason(reason: any): string {
    if (reason === ModalDismissReasons.ESC) {
      return "by pressing ESC";
    } else if (reason === ModalDismissReasons.BACKDROP_CLICK) {
      return "by clicking on a backdrop";
    } else {
      return `with: ${reason}`;
    }
  }

}
